module.exports = __webpack_public_path__ + "media/goforajourney/img/mexico-city-tour-4c467dc938c1feddf59fed4ebe9b05e0.jpg";